<div class="bg-white rounded-2xl shadow-sm overflow-hidden">
    <button class="w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 transition-colors"
        (click)="clickExpand()">
        <div class="flex items-center gap-2">
            <span class="font-medium text-gray-900">{{classForm?.value?.name}}組</span>
            <span class="text-sm text-gray-500">({{studentFormsValue.length}}名)</span>
            <div class="flex items-center gap-1" *ngIf="dirtyForms.length > 0">
                <span class="bg-blue-600 text-white text-xs px-2 py-0.5 rounded-full">{{dirtyForms.length}}件作成中</span>
            </div>
            <div class="flex items-center gap-1" *ngIf="submittedForms.length > 0">
                <span
                    class="bg-green-600 text-white text-xs px-2 py-0.5 rounded-full">{{submittedForms.length}}件保存済み</span>
            </div>
        </div>

        <app-dropdown-arrow [expanded]="expanded"></app-dropdown-arrow>
    </button>
    <!-- list here -->
    <div class="border-t border-gray-200 dropdown-list" [class.expanded]="expanded" [class.collapsed]="!expanded">
        <ng-container *ngFor="let student of studentFormsControl">
            <app-student-record-item [studentForm]="$any(student)"></app-student-record-item>
        </ng-container>
    </div>
</div>